import { EVENT_API } from '../components/pages/config';

/* ─── CREATE ───────────────────────────────────────────── */
export async function createEvent(data) {
  const res = await fetch(`${EVENT_API}/create-event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error((await res.json()).message || 'Error creating event');
  return res.json();
}

/* ─── UPDATE ───────────────────────────────────────────── */
export async function updateEvent(event_id, updateData) {
  const res = await fetch(`${EVENT_API}/update-event`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event_id, ...updateData }),
  });
  if (!res.ok) throw new Error((await res.json()).message || 'Error updating event');
  return res.json();
}

/* ─── GET ONE ──────────────────────────────────────────── */
export async function getEventById(event_id) {
  const res = await fetch(`${EVENT_API}/event?event_id=${event_id}`);
  if (!res.ok) throw new Error((await res.json()).message || 'Error fetching event');
  return res.json();
}

/* ─── GET BY USER ──────────────────────────────────────── */
export async function getEventsForUser(user_id) {
  const res = await fetch(`${EVENT_API}/events?user_id=${user_id}`);
  if (!res.ok) throw new Error((await res.json()).message || 'Error fetching events');
  return res.json();
}

/* ─── DELETE ───────────────────────────────────────────── */
export async function deleteEvent(event_id) {
  const res = await fetch(`${EVENT_API}/delete-event?event_id=${event_id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error((await res.json()).message || 'Error deleting event');
  return res.json();
}
